import { render, staticRenderFns } from "./PageOptions.vue?vue&type=template&id=3718fc39&lang=pug"
import script from "./PageOptions.vue?vue&type=script&lang=js"
export * from "./PageOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports